export function isRelayerStep(step) {
    return !!step.typedData && step.typedData.length > 0;
}
export function isGaslessStep(step) {
    return !!step.typedData?.find((p) => p.primaryType === 'PermitWitnessTransferFrom');
}
//# sourceMappingURL=typeguards.js.map